/* dl-rail.js — design—light · export 03
   Keeps every [data-dl-rail] grid ending on a full row (handoff 02 §6.1).
   Tiles are hidden with the `hidden` property, which dl-tokens.css enforces
   with [hidden]{display:none!important} so a class `display` can never win. */
(function () {
  var rails = Array.prototype.slice.call(document.querySelectorAll("[data-dl-rail]"));
  if (!rails.length) return;

  function cols(el) {
    var t = getComputedStyle(el).gridTemplateColumns;
    return t && t !== "none" ? t.split(" ").length : 1;
  }
  function trim(el) {
    var tiles = Array.prototype.slice.call(el.children);
    tiles.forEach(function (t) { t.hidden = false; });
    var c = cols(el);
    if (c < 2) return;
    var keep = Math.floor(tiles.length / c) * c;
    if (keep < c) keep = Math.min(tiles.length, c); /* never blank a short rail */
    tiles.slice(keep).forEach(function (t) { t.hidden = true; });
  }
  function run() { rails.forEach(trim); }

  run();
  var t = null;
  addEventListener("resize", function () { clearTimeout(t); t = setTimeout(run, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
})();
